/*
Ties the `aria-activedescendant` the input reports to the id on the highlighted
option, so both sides derive the same id from the listbox id and the row index.
*/
export function buildCarrierSearchOptionId(
  listboxId: string,
  index: number,
): string {
  return `${listboxId}-option-${index}`;
}
